/**
 * Created by rathompson on 1/9/24
 * File: CancelAcquisitionModal.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */

import type { VFC } from 'react'
import {
  Body,
  Bold,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalProps,
  useIsMounted
} from '@panwds/react-ui'
import { useCallback, useContext, useMemo, useState } from 'react'
import {
  BUTTON_CANCEL_ACQUISITION,
  LABEL_CANCEL_ACQ_SUBTEXT,
  TITLE_CANCEL_ACQ,
} from '../../constants/LabelConstants'
import { safeSet } from '../../../common/utils/Utils'
import TenancyService from '../../services/TenancyService'
import ScreenLoader from '../../../activation/components/common/ScreenLoader'
import { Modal } from '../../../common/components/modal/Modal'
import GlobalContext from '../../../common/context/GlobalContext'
import { BUTTON_CANCEL } from '../../../common/constants/LabelConstants'
import StringTemplate from '../../../common/utils/StringTemplate'

const CancelAcquisitionModal: VFC<ModalProps & {
  closeModal: any,
  acquisition: any,
  onDelete: any
}> = ({ isOpen, closeModal, acquisition, onDelete }) => {

  const isMounted = useIsMounted()
  const { treeReducer } = useContext(GlobalContext)
  const { selectedTreeNode } = treeReducer

  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  const title = useMemo(() => {
    return StringTemplate(TITLE_CANCEL_ACQ, [acquisition.target_tsg_id])
  }, [acquisition.target_tsg_id])

  const onCancelClick = useCallback(async () => {
    try {
      safeSet(setLoading, true, isMounted.current)
      await TenancyService.acquisitions.delete(selectedTreeNode.id, acquisition.id)
      closeModal()
      onDelete(acquisition)
    }
    catch (error: any) {
      safeSet(setError, error.message, isMounted.current)
    }
    finally {
      safeSet(setLoading, false, isMounted.current)
    }
  }, [acquisition, closeModal, isMounted, onDelete, selectedTreeNode.id])

  return (
    <Modal
      onClose={closeModal}
      { ...{ isOpen } }
    >
      <ModalHeader {...{ title }} />
      <ModalBody addClassName='cm-flex cm-flex-col cm-gap-2'>
        {loading && <ScreenLoader appearance='light'/>}
        {error && <Bold appearance='semibold' addClassName='tw-text-error'>{error}</Bold>}
        <Body size='md'>{LABEL_CANCEL_ACQ_SUBTEXT}</Body>
      </ModalBody>
      <ModalFooter>
        <ModalCloseButton appearance='secondary'>{BUTTON_CANCEL}</ModalCloseButton>
        <Button
          appearance="secondary-destructive"
          onClick={onCancelClick}
        >{BUTTON_CANCEL_ACQUISITION}</Button>
      </ModalFooter>
    </Modal>
  )
}

export default CancelAcquisitionModal
